<template>
  <div id="screen" class="ui center aligned basic segment" style="overflow:auto;display:flex;margin:0">
    <div class="ui center aligned container purple segment" style="display:inline-block;margin:auto">
      <h3 class="header">Inspection history</h3>
      <div class="ui divided items" style="text-align:left">
        <InspectionListitem v-for="ins in this.inspections" :key="ins._id" :ins="ins" @printInspectionEvent="printInspection"/>
      </div>
    </div>
  </div>
</template>

<script>
  import InspectionListitem from '@/components/InspectionListitem.vue'

  function getLocationOfIns(ins, thiz) {
    var i;
    var l = ins.location;
    if (!ins.location) {
      return '- no data -';
    }

    if (typeof ins.location === 'string') {
      try {
        l = JSON.parse(ins.location);
        ins.location = l;
      }
      catch(e){
        console.log('error', e);
      }
    }

    if (typeof l === 'object') {
      if (l.lat) {
        return 'Lat:'+l.lat+', lon:'+l.lon;
      }
      else if (l.id) {
        for (i=0; i< thiz.locations.length; i++) {
          if (thiz.locations[i].id === l.id) return thiz.locations[i].firstname+' '+thiz.locations[i].surname+'('+thiz.locations[i].companyname+')';
        }

        return 'invalid value:'+JSON.stringify(l);
      }
    }

    if (typeof l === 'number') {
      for (i=0; i< thiz.locations.length; i++) {
        if (thiz.locations[i].id === l.id) return thiz.locations[i].firstname+' '+thiz.locations[i].surname+'('+thiz.locations[i].companyname+')';
      }
    }

    return l;
  }

  function getInspectionSummary(ins, thiz) {
    var t='';
    
    var nums = {
      '1':1,
      '2':2,
      '3':3,
      '4':4
    };

    var ftl = {
      'E': "empty",
      "1/8":'one eighth',
      '1/4':'quarter',
      "3/8":'three eighth',
      '1/2':'half',
      "5/8":'five eighth',
      '3/4':'three quarters',
      "7/8":"seven eighth",
      'F':'full'
    };
    
    var cleans={
      "clean":"Clean",
      "dust":"Light dust",
      "small":"Small cleaning required",
      "medium":"Medium cleaning required",
      "dirty":"Full cleaning required"
    };
    
    var dps = {
      "na":"not applicable",
      "allgood":"all in good condition",
      "slightlydamaged":"slightly damaged",
      "damaged":"damaged",
      "onemissing":",one missing",
      "allmissing":"all missing"
    };
    
    var umb= {
      "na":"not applicable",
      "0f2":"2 umbrellas",
      "1f2":"1 of 2 missing",
      "2f2":"2 of 2 missing",
      "0f4":"4 umbrellas",
      "1f4":"1 of 4 missing",
      "2f4":"2 of 4 missing",
      "3f4":"3 of 4 missing",
      "4f4":"4 of 4 missing"
    };
    
    var spw = {
      "na":"not applicable",
      "good":"in good condition",
      "damaged":"damaged",
      "missing":"missing",
      "nowarnings":"no warnings",
      "warnings":"warning(s)",
      "present":"present",
      "hbp":"handbook present",
      "clean":"clean",
      "empty":"empty"
    };
    
    var png = {
      "na":"not applicable",
      "allgood":"both present",
      "onlypump":"only pump",
      "onlygunk":"only tyre repair kit",
      "bothmissing":"both missing"
    };

    var tyres = {
      'ok':'Ok',
      'damaged':'Damaged',
      'wear':'Wear'
    };


    var yesno = {
      'yes':'Yes',
      'no':'No'
    }
    
    ins.location = getLocationOfIns(ins, thiz);
    t += 'Location:'+ins.location+'; ';
    t += 'Mileage:'+ins['mileage']+'; ';
    t += 'Fuel: '+ftl[ins.fuellevel]+'; ';
    t += cleans[ins.insideclean]+' inside, ';
    t += cleans[ins.outsideclean]+' outside; ';
    if (ins['numkeys']) t += 'Keys: '+nums[ins.numkeys]+', ';
    if (ins['tyres']) t += 'Tyres: '+tyres[ins.tyres]+', ';
    if (ins['parcelshelf']) t += 'Parcel shelf: '+yesno[ins.parcelshelf]+', ';
    t += 'Door protectors: '+dps[ins.doorprotectors]+'; ';
    t += 'Glovebox: '+spw[ins.glovebox]+'; ';
    t += 'Centre console: '+spw[ins.cconsole]+'; ';
    t += 'Wheelnut: '+spw[ins.wheelnut]+'; ';
    t += 'Door pockets: '+spw[ins.doorpockets]+'; ';
    t += 'Dashboard lights: ';
    if (ins.dashlights && ins.dashlights.length>0) {
      t+= ins.dashlights;
    }
    else {
      t+='-';
    }
    t+= '; ';

    t += 'Any other: ';
    if (ins.anyother && ins.anyother.length>0) {
      t+=ins.anyother;
    }
    else {
      t+='-';
    }
    t+='; ';

    t += 'Umbrellas: '+umb[ins.umbrellas]+ ';';
    t += 'Spare wheel: '+spw[ins.sparewheel]+'; ';
    t += 'Pump&amp;tyre repair kit:'+png[ins.pumpngunk];
//    t += 'Navigation SD card: '+nsd[ins.sdcard];
    
    if (!ins.damages) ins.damages =[];
    
    return t;
  }

  export default {
    components: {
      InspectionListitem
    },
    methods: {
      printInspection(reg, iid) {
        console.log(reg, iid);
        var f = document.getElementById('pframe');
        if (f && f.parent && f.parent.removeChild) f.parent.removeChild(f);

        f = document.createElement('a');
        f.style.display = 'none';
        document.body.append(f);
        f.setAttribute('href',this.$host+'/inspection.print.html?reg='+reg+'&iid='+iid, '_blank');
	f.setAttribute('id','pframe');
	f.dispatchEvent(new Event('click', {bubbles:true}));
      }
    },
    data() {
      return {
        inspections: [],
        locations: [
          {
            "id": 1674,
            "companyname": "IDS Auto",
            "firstname": "Simon",
            "surname": "Coulson",

          },
          {
            "id": 1675,
            "companyname": "AB vehicle Repairs",
            "firstname": "Aaron ",
            "surname": " Bodger"
          },
          {
            "id": 1676,
            "companyname": "Harben House",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1677,
            "companyname": "Northants Mobile Tyres",
            "firstname": "Paul",
            "surname": ""
          },
          {
            "id": 1678,
            "companyname": "Tanya Cavill",
            "firstname": "Tanya",
            "surname": "Cavill"
          },
          {
            "id": 1679,
            "companyname": "Karen Coulson",
            "firstname": "Karen ",
            "surname": "Coulson"
          },
          {
            "id": 43,
            "companyname": "Duckend",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 44,
            "companyname": "Elsenham",
            "firstname": "",
            "surname": "",
            "lat":51.923056,
            "lon":0.256667
          },
          {
            "id": 45,
            "companyname": "Felsted",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 47,
            "companyname": "North Weald",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 48,
            "companyname": "The Manor",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 49,
            "companyname": "24x7 Stansted Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 50,
            "companyname": "Owen (practical parking)",
            "firstname": "Owen",
            "surname": ""
          },
          {
            "id": 52,
            "companyname": "Scrap Yard",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 72,
            "companyname": "Hants Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 73,
            "companyname": "Bucks Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 75,
            "companyname": "Lincs Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 78,
            "companyname": "Northants Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 79,
            "companyname": "West Sussex Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 81,
            "companyname": "Allocated To Driver",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 86,
            "companyname": "Runaround Vehicle",
            "firstname": "Runaround",
            "surname": "Vehicle"
          },
          {
            "id": 90,
            "companyname": "De-allocated By Driver",
            "firstname": "Andrew",
            "surname": "Gregory"
          },
          {
            "id": 93,
            "companyname": "PR Motors",
            "firstname": "Philip",
            "surname": "White"
          },
          {
            "id": 97,
            "companyname": "Rowland Ridgwells ltd",
            "firstname": "Sally / Ben",
            "surname": ""
          },
          {
            "id": 99,
            "companyname": "Smarts",
            "firstname": "Jamie / Rob",
            "surname": ""
          },
          {
            "id": 100,
            "companyname": "Airport Garage Services",
            "firstname": "Bruce",
            "surname": ""
          },
          {
            "id": 101,
            "companyname": "Oakdene Autos",
            "firstname": "Reece / Tracy",
            "surname": ""
          },
          {
            "id": 103,
            "companyname": "Toomey Renault ",
            "firstname": "Charlie",
            "surname": ""
          },
          {
            "id": 104,
            "companyname": "Quest Motor Group",
            "firstname": "Quest Motor Group",
            "surname": ""
          },
          {
            "id": 105,
            "companyname": "Quest Vauxhall",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 110,
            "companyname": "Ash Mahoney",
            "firstname": "Ashley ",
            "surname": "Mahoney"
          },
          {
            "id": 111,
            "companyname": "Specialist Vehicle solutions",
            "firstname": "steve",
            "surname": "Manning"
          },
          {
            "id": 112,
            "companyname": "Algarve",
            "firstname": "Tom",
            "surname": ""
          },
          {
            "id": 113,
            "companyname": "Barnston travel",
            "firstname": "Richard",
            "surname": "Barnston Travel"
          },
          {
            "id": 114,
            "companyname": "Andy Mahoney",
            "firstname": "Andy",
            "surname": "Mahoney"
          },
          {
            "id": 115,
            "companyname": "Awaiting Delivery",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 116,
            "companyname": "Kent Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 117,
            "companyname": "T AND S VEHICLE REPAIRS NORFOLK",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 118,
            "companyname": "Second Vehicle",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 120,
            "companyname": "Arrived @N/W",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 123,
            "companyname": "Mag airport",
            "firstname": "Mag airport",
            "surname": ""
          },
          {
            "id": 127,
            "companyname": "COMPLETE TAIL LIFT SOLUTIONS",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 129,
            "companyname": "SPEEDY SCREENS YARD",
            "firstname": "SPEEDY SCREENS YARD",
            "surname": ""
          },
          {
            "id": 130,
            "companyname": "SPEEDY SCREENS",
            "firstname": "SPEEDY SCREENS",
            "surname": ""
          },
          {
            "id": 131,
            "companyname": "SPEEDY SCREENS",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 132,
            "companyname": "KIA WESTDRIVE BRAINTREE",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 145,
            "companyname": "Motts Hall",
            "firstname": "Motts Hall",
            "surname": ""
          },
          {
            "id": 150,
            "companyname": "Peugeot Main Dealer",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 157,
            "companyname": "Staffs Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 168,
            "companyname": "compound",
            "firstname": "compound",
            "surname": ""
          },
          {
            "id": 183,
            "companyname": "Long Stay Q",
            "firstname": "Long Stay Q",
            "surname": ""
          },
          {
            "id": 193,
            "companyname": "WR MOTORS",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 196,
            "companyname": "TRANSCITY",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 199,
            "companyname": "Gates",
            "firstname": "Ford Gates",
            "surname": ""
          },
          {
            "id": 200,
            "companyname": "Delivered",
            "firstname": "Delivered",
            "surname": ""
          },
          {
            "id": 201,
            "companyname": "Learner vehicle",
            "firstname": "Learner vehicle",
            "surname": ""
          },
          {
            "id": 206,
            "companyname": "Boyers Garage",
            "firstname": "Boyers Garage",
            "surname": ""
          },
          {
            "id": 209,
            "companyname": "Lancashire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 220,
            "companyname": "Northumberland and Tyne and Wear Office",
            "firstname": null,
            "surname": null
          },
          {
            "id": 227,
            "companyname": "Bedfordshire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 228,
            "companyname": "Lancashire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 229,
            "companyname": "Cheshire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 230,
            "companyname": "Warwickshire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 231,
            "companyname": "Shropshire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 232,
            "companyname": "County Durham Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 233,
            "companyname": "East Riding Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 245,
            "companyname": "North Yorkshire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 253,
            "companyname": "Cornwall Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 254,
            "companyname": "East Sussex Office",
            "firstname": "lee ",
            "surname": "Wadey"
          },
          {
            "id": 257,
            "companyname": "Oxfordshire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 258,
            "companyname": "Gloucestershire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 259,
            "companyname": "Somerset Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 260,
            "companyname": "Devon Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 261,
            "companyname": "Worcestershire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 262,
            "companyname": "Derbyshire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 288,
            "companyname": "Nottinghamshire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 297,
            "companyname": "Quest Citroen SOR",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 300,
            "companyname": "Dorset Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 301,
            "companyname": "Mid Stay car park A",
            "firstname": "Mid stay car park A",
            "surname": ""
          },
          {
            "id": 302,
            "companyname": "Adam Motor garage ltd",
            "firstname": "Adams Motor",
            "surname": ""
          },
          {
            "id": 306,
            "companyname": "Bristol Street Harlow",
            "firstname": "bristol street Harlow",
            "surname": ""
          },
          {
            "id": 307,
            "companyname": "Essex Autos repair",
            "firstname": "Essex Autos ",
            "surname": ""
          },
          {
            "id": 308,
            "companyname": "WestdrIve SOR",
            "firstname": "Westdrive SOR",
            "surname": ""
          },
          {
            "id": 309,
            "companyname": "Station Coachworks",
            "firstname": "Station Coachworks",
            "surname": ""
          },
          {
            "id": 313,
            "companyname": "Pickrell Ltd",
            "firstname": "Chris",
            "surname": ""
          },
          {
            "id": 317,
            "companyname": "Marshalls Oxford",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 321,
            "companyname": "STN - Awaiting Garage",
            "firstname": "Awaiting Garage",
            "surname": ""
          },
          {
            "id": 337,
            "companyname": "Midstay A",
            "firstname": "Midstay A",
            "surname": ""
          },
          {
            "id": 339,
            "companyname": "Midstay B",
            "firstname": "Midstay B",
            "surname": ""
          },
          {
            "id": 340,
            "companyname": "Midstay B",
            "firstname": "Midstay B",
            "surname": ""
          },
          {
            "id": 341,
            "companyname": "Midstay B",
            "firstname": "Midstay  B",
            "surname": ""
          },
          {
            "id": 342,
            "companyname": "Midstay C",
            "firstname": "Midstay C",
            "surname": ""
          },
          {
            "id": 343,
            "companyname": "Midstay D",
            "firstname": "Midstay D",
            "surname": ""
          },
          {
            "id": 344,
            "companyname": "Midstay E",
            "firstname": "Midstay E",
            "surname": ""
          },
          {
            "id": 345,
            "companyname": "Midstay F",
            "firstname": "MIdstay F",
            "surname": ""
          },
          {
            "id": 347,
            "companyname": "Midstay G",
            "firstname": "Midstay G",
            "surname": ""
          },
          {
            "id": 348,
            "companyname": "Midstay H",
            "firstname": "Midstay H",
            "surname": ""
          },
          {
            "id": 358,
            "companyname": "Smart repair centre",
            "firstname": "Smart repair centre",
            "surname": ""
          },
          {
            "id": 359,
            "companyname": "kia",
            "firstname": "Kia",
            "surname": ""
          },
          {
            "id": 360,
            "companyname": "Bodyworx ltd",
            "firstname": "Barry",
            "surname": ""
          },
          {
            "id": 373,
            "companyname": "Aske Stables North Storage",
            "firstname": "Aske Stables north storage",
            "surname": ""
          },
          {
            "id": 374,
            "companyname": "Ian Norfolk",
            "firstname": "Ian Norfolk",
            "surname": "Ian Batley"
          },
          {
            "id": 376,
            "companyname": "Marshs Farm Dunmow",
            "firstname": "Marshs Farm Dunmow",
            "surname": ""
          },
          {
            "id": 380,
            "companyname": "HAARLEM STORAGE DERBYSHIRE",
            "firstname": "HAARLEM STORAGE DERBYSHIRE",
            "surname": "HAARLEM STORAGE DERBYSHIRE"
          },
          {
            "id": 381,
            "companyname": "24x7 Group",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 383,
            "companyname": "Norfolk Office",
            "firstname": "Norfolk Office",
            "surname": "Ian Batley"
          },
          {
            "id": 897,
            "companyname": "Leicestershire Office",
            "firstname": "Guy",
            "surname": "Atkinson"
          },
          {
            "id": 907,
            "companyname": "Somerset Vauxhall storage TEMP",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 910,
            "companyname": "Fargo 24x7",
            "firstname": "Fargo",
            "surname": "Fargo"
          },
          {
            "id": 911,
            "companyname": "Matt Auto Repairs",
            "firstname": "MARS",
            "surname": "Matts Auto Repairs "
          },
          {
            "id": 915,
            "companyname": "Stoke Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 919,
            "companyname": "LETCHWORTH TOYOTA COMPOUND",
            "firstname": "LETCHWORTH TOYOTA COMPOUND",
            "surname": "LETCHWORTH TOYOTA COMPOUND"
          },
          {
            "id": 923,
            "companyname": "Surrey Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 924,
            "companyname": "Vauxhall Thurlow Nunn storage luton",
            "firstname": "Vauxhall Thurlow Nunn storage luton",
            "surname": ""
          },
          {
            "id": 937,
            "companyname": "Speedy Repairs",
            "firstname": "Speedy Repairs",
            "surname": ""
          },
          {
            "id": 938,
            "companyname": "County Motorworks",
            "firstname": "County Motorworks",
            "surname": ""
          },
          {
            "id": 942,
            "companyname": "Start Hill",
            "firstname": "Start Hill",
            "surname": "",
            "lat":51.869722,
            "lon":0.214722
          },
          {
            "id": 944,
            "companyname": "Bishops Stortford Toyota",
            "firstname": "Bishops Stortford Toyota",
            "surname": "Bishops Stortford Toyota"
          },
          {
            "id": 947,
            "companyname": "East Sussex Storage",
            "firstname": "EAST SUSSEX STORAGE",
            "surname": "East Sussex Storage",
            "lat":50.884722,
            "lon":0.426944
          },
          {
            "id": 950,
            "companyname": "Diamond Hanger",
            "firstname": "",
            "surname": "",
            "lat":51.875278,
            "lon": 0.234444
          },
          {
            "id": 955,
            "companyname": "SOUTH WEST STORAGE DORSET",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 956,
            "companyname": "Lincolnshire STORAGE",
            "firstname": "Lincolnshire STORAGE",
            "surname": ""
          },
          {
            "id": 957,
            "companyname": "OXFORD/GLOUCESTERSHIRE STORAGE",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 960,
            "companyname": "Raynes Bodywork",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 964,
            "companyname": "SR Motorworks",
            "firstname": "Jodie / Scott",
            "surname": ""
          },
          {
            "id": 965,
            "companyname": "Takeley Performance Tyres",
            "firstname": "Michael",
            "surname": "Logan"
          },
          {
            "id": 972,
            "companyname": "Muirs Vehicle Services",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 981,
            "companyname": "Underwood Vauxhall",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 986,
            "companyname": "Martock somerset TA12 6HB STORAGE",
            "firstname": "Martock somerset TA12 6HB",
            "surname": "Martock somerset TA12 6HB",
            "lat":50.979722,
            "lon":-2.768333
          },
          {
            "id": 995,
            "companyname": "renault chelmsford ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 999,
            "companyname": "The WorkShop",
            "firstname": "David",
            "surname": "Thompson"
          },
          {
            "id": 1554,
            "companyname": "Cumbria Office",
            "firstname": "Mandy",
            "surname": "Davies"
          },
          {
            "id": 1555,
            "companyname": "Manchester Office",
            "firstname": "Steve",
            "surname": "Mockl"
          },
          {
            "id": 1565,
            "companyname": "WIltshire Office",
            "firstname": "Pete",
            "surname": "Winn"
          },
          {
            "id": 1576,
            "companyname": "DAVE THOMPSON BODY REPAIRS",
            "firstname": "DAVE THOMPSON BODY REPAIRS",
            "surname": "DAVE THOMPSON BODY REPAIRS"
          },
          {
            "id": 1626,
            "companyname": "White Bodyworks",
            "firstname": "David",
            "surname": "White"
          },
          {
            "id": 1657,
            "companyname": "JAGUARS",
            "firstname": "JAGUARS",
            "surname": "JAGUARS.",
            "lat":51.866667,
            "lon":0.269167
          },
          {
            "id": 1683,
            "companyname": "DH COLLECTION BOOKED",
            "firstname": "DH COLLECTION BOOKED",
            "surname": "DH COLLECTION BOOKED"
          },
          {
            "id": 1698,
            "companyname": "Stanford Coachworks ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1700,
            "companyname": "GM CLEMENTS",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1707,
            "companyname": "BRAINTREE STORAGE",
            "firstname": "BRAINTREE STORAGE",
            "surname": "BRAINTREE STORAGE",
            "lat":51.866389,
            "lon":0.583889
          },
          {
            "id": 1717,
            "companyname": "ESSEX BODYWORKS",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1759,
            "companyname": "ALAN AND DAY",
            "firstname": "ALAN&DAY PETERBOUGH",
            "surname": ""
          },
          {
            "id": 1783,
            "companyname": "Harris Truck & Bus ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1528,
            "companyname": "Hertfordshire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 82,
            "companyname": "Spare at Craigs",
            "firstname": "Craigs ",
            "surname": "House"
          },
          {
            "id": 83,
            "companyname": "Spare at Phillips",
            "firstname": "Phillip",
            "surname": "Henley"
          },
          {
            "id": 84,
            "companyname": "Spare at Davids",
            "firstname": "David",
            "surname": "Rudd"
          },
          {
            "id": 85,
            "companyname": "Spare with Driver see location note",
            "firstname": "Spare",
            "surname": "Spare"
          },
          {
            "id": 152,
            "companyname": "Approved Autos Ltd",
            "firstname": "Jody",
            "surname": ""
          },
          {
            "id": 153,
            "companyname": "Tyre Shops - Hedge End",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 154,
            "companyname": "Tyre Shops - Whiteley",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 156,
            "companyname": "Auto Electrics ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 158,
            "companyname": "Picador Vauxhall Southampton",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 164,
            "companyname": "Snows Peugeot Basingstoke",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 174,
            "companyname": "Basingstoke MOT & Servicing Centre",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 212,
            "companyname": "",
            "firstname": "Wilmoths Citroen Winchester",
            "surname": ""
          },
          {
            "id": 213,
            "companyname": "",
            "firstname": "Wilmoths Citroen Winchester",
            "surname": ""
          },
          {
            "id": 214,
            "companyname": "",
            "firstname": "Wilmoths Citroen Winchester",
            "surname": ""
          },
          {
            "id": 215,
            "companyname": "",
            "firstname": "Wilmoths Citroen Winchester",
            "surname": ""
          },
          {
            "id": 216,
            "companyname": "Wilmoths Citroen Winchester",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 239,
            "companyname": "Aldershot Vauxhall",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 242,
            "companyname": "Boarhunt Garage",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 243,
            "companyname": "Castle Body Works",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 303,
            "companyname": "Garland Motors",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 903,
            "companyname": "West End Garage (Kia)",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 908,
            "companyname": "Marshall Volkswagen Reading",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 913,
            "companyname": "Eden Vauxhall Fareham",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 917,
            "companyname": "South Coast Tail Lift Repairs Limited",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 926,
            "companyname": "Meadens Å KODA Brockenhurst",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 935,
            "companyname": "Richmond Å KODA Fareham",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 940,
            "companyname": "Spare at Phil D",
            "firstname": "Phil",
            "surname": "Drayton"
          },
          {
            "id": 941,
            "companyname": "Spare at Barry S",
            "firstname": "Barry ",
            "surname": "Stephens"
          },
          {
            "id": 949,
            "companyname": "Takeley Performance Tyres & Exhausts",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 959,
            "companyname": "Camberley Skoda",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 961,
            "companyname": "Botley Skoda",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 962,
            "companyname": "Snows Toyota Waterlooville",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 993,
            "companyname": "Martins Renault Basingstoke",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 994,
            "companyname": "Aldershot Repairs",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1014,
            "companyname": "Snows Toyota",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1015,
            "companyname": "Colour Motion Ltd",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1016,
            "companyname": "Colour Motion Ltd",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1541,
            "companyname": "St.Georges Coachworks Ltd",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1544,
            "companyname": "Vauxhall Service Centre Portsmouth",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1556,
            "companyname": "St.Georges Coachworks Ltd",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1640,
            "companyname": "Ravenscroft",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1737,
            "companyname": "Priory Garage",
            "firstname": "John",
            "surname": ""
          },
          {
            "id": 1769,
            "companyname": "",
            "firstname": "Martins Dacia Basingstoke",
            "surname": ""
          },
          {
            "id": 384,
            "companyname": "Norfolk Office",
            "firstname": "Norfolk Office",
            "surname": "Coulson"
          },
          {
            "id": 1773,
            "companyname": "Brian Huggins",
            "firstname": "Brian",
            "surname": "Huggins"
          },
          {
            "id": 1715,
            "companyname": "Highfield Services",
            "firstname": "Derek",
            "surname": ""
          },
          {
            "id": 1728,
            "companyname": "kia citygate",
            "firstname": "citygate kia",
            "surname": ""
          },
          {
            "id": 1729,
            "companyname": "kia citygate",
            "firstname": "citygate kia",
            "surname": ""
          },
          {
            "id": 1730,
            "companyname": "kia citygate",
            "firstname": "citygate kia",
            "surname": ""
          },
          {
            "id": 1552,
            "companyname": "XL Garage LTD",
            "firstname": "Simon",
            "surname": "Dennis"
          },
          {
            "id": 1671,
            "companyname": "RT Autos",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1672,
            "companyname": "Storit Main Storage",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 2,
            "companyname": "Dragon Design and Development",
            "firstname": "Andrew",
            "surname": "Gregory"
          },
          {
            "id": 1002,
            "companyname": "Off Road",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 141,
            "companyname": "",
            "firstname": "North weald",
            "surname": ""
          },
          {
            "id": 182,
            "companyname": "Long Stay Q",
            "firstname": "Long Stay Q",
            "surname": ""
          },
          {
            "id": 338,
            "companyname": "",
            "firstname": "Midstay A",
            "surname": ""
          },
          {
            "id": 1690,
            "companyname": "Group 1 Toyota Medway",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1720,
            "companyname": "Panel Pride",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1721,
            "companyname": "Express MOT & Autocentre",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1722,
            "companyname": "Marshall Skoda Canterbury",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1723,
            "companyname": "Marshall Skoda Dartford",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1724,
            "companyname": "National Windscreens ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1725,
            "companyname": "",
            "firstname": "Andrea",
            "surname": "Majerska"
          },
          {
            "id": 1684,
            "companyname": "Monkey Puzzle",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1685,
            "companyname": "Se tyres ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1686,
            "companyname": "Pro Paint ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1687,
            "companyname": "Yeoman Toyota ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1688,
            "companyname": "Eastbourne Motoring Centre",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1689,
            "companyname": "Ninfield Auto Restoration",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1775,
            "companyname": "K. Pritchard",
            "firstname": "Kevin",
            "surname": "Pritchard"
          },
          {
            "id": 1777,
            "companyname": "Kia Stafford",
            "firstname": "Kia",
            "surname": "Stafford"
          },
          {
            "id": 356,
            "companyname": "Northumberland Tyne & Wear Compound",
            "firstname": "Jim",
            "surname": ""
          },
          {
            "id": 361,
            "companyname": "Cambridgeshire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 967,
            "companyname": "",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 968,
            "companyname": "Dealership or Motor Service",
            "firstname": "Any",
            "surname": "Body"
          },
          {
            "id": 969,
            "companyname": "NCC Alnwick Depot",
            "firstname": "Chris ",
            "surname": "Chisholm"
          },
          {
            "id": 1559,
            "companyname": "TH Nixon & Sons",
            "firstname": "John",
            "surname": "Nixon"
          },
          {
            "id": 1560,
            "companyname": "Wilsons Auto Service Centre",
            "firstname": "Jack",
            "surname": "Wilson"
          },
          {
            "id": 1561,
            "companyname": "Axiom Repair",
            "firstname": "Alex",
            "surname": "Beacham"
          },
          {
            "id": 1670,
            "companyname": "Hengora Tyres & Repairs",
            "firstname": "Brad",
            "surname": "Fogerty"
          },
          {
            "id": 1692,
            "companyname": "NTW - 24x7 Ltd - MB",
            "firstname": "Michael ",
            "surname": "Baister"
          },
          {
            "id": 1732,
            "companyname": "NTW - 24x7 LTD - LC",
            "firstname": "Laurence",
            "surname": "Clarkson"
          },
          {
            "id": 1738,
            "companyname": "Pulman Skoda",
            "firstname": "Blayne",
            "surname": "Fitzjohn"
          },
          {
            "id": 1680,
            "companyname": "AB vehicle Repairs",
            "firstname": "Aaron",
            "surname": "Bodger"
          },
          {
            "id": 1681,
            "companyname": "Harben House",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1748,
            "companyname": "Solihull Vehicle Service Centre ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1654,
            "companyname": "Shropshire Yard",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1655,
            "companyname": "Shropshire - Just MOTs",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1658,
            "companyname": "Shropshire - Telford Paint & Body",
            "firstname": "Pete",
            "surname": ""
          },
          {
            "id": 1659,
            "companyname": "Telford Paint & Body",
            "firstname": "Pete",
            "surname": ""
          },
          {
            "id": 1660,
            "companyname": "Shropshire - AJS Motorworks",
            "firstname": "Alex",
            "surname": ""
          },
          {
            "id": 1767,
            "companyname": "24x7 Ltd Haarlam",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1652,
            "companyname": "John Roe Toyota",
            "firstname": "Matthew",
            "surname": "Hill"
          },
          {
            "id": 1696,
            "companyname": "Beadle Motors",
            "firstname": "David",
            "surname": "Beadle"
          },
          {
            "id": 1697,
            "companyname": "High Finish Express",
            "firstname": "Stuart",
            "surname": ""
          },
          {
            "id": 1699,
            "companyname": "Evans Halshaw Vauxhall",
            "firstname": "Vicky ",
            "surname": "Lewis"
          },
          {
            "id": 1764,
            "companyname": "Parked Up at Drivers Home",
            "firstname": "Driver",
            "surname": "Driver"
          },
          {
            "id": 1766,
            "companyname": "Main Dealership",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1746,
            "companyname": "",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1747,
            "companyname": "Par Yard",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1752,
            "companyname": "Yeomans Skoda",
            "firstname": "Ryan",
            "surname": ""
          },
          {
            "id": 1762,
            "companyname": "Witney Yard ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1763,
            "companyname": "Three Corners Garage ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1789,
            "companyname": "Lydbrook Valley Garage",
            "firstname": "Matt",
            "surname": ""
          },
          {
            "id": 1791,
            "companyname": "Debra Cheltenham cover Driver",
            "firstname": "Debra",
            "surname": "Morris"
          },
          {
            "id": 1792,
            "companyname": "Tims - FCBC",
            "firstname": "Tim ",
            "surname": "Deakins"
          },
          {
            "id": 1793,
            "companyname": "24x7 Wiltshire Swindon Carpark",
            "firstname": "Pete ",
            "surname": "Winn"
          },
          {
            "id": 1772,
            "companyname": "Yeovil Accident Repair",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1661,
            "companyname": "Morecraft",
            "firstname": "Andy",
            "surname": "Phillips"
          },
          {
            "id": 1662,
            "companyname": "Motor Link Servicing & Repairs",
            "firstname": "Michelle ",
            "surname": "Lazenby "
          },
          {
            "id": 1701,
            "companyname": "KWIK FIT MATLOCK",
            "firstname": "KWIK FIT MATLOCK",
            "surname": "KWIK FIT MATLOCK"
          },
          {
            "id": 1702,
            "companyname": "SCOTTS AUTO'S WIRKSWORTH",
            "firstname": "SCOTTS AUTO'S WIRKSWORTH",
            "surname": "SCOTTS AUTO'S WIRKSWORTH"
          },
          {
            "id": 1703,
            "companyname": "SCOTTS AUTO' S MATLOCK BATH",
            "firstname": "SCOTTS AUTO'S MATLOCK BATH",
            "surname": "SCOTTS AUTO'S MATLOCK BATH"
          },
          {
            "id": 1704,
            "companyname": "AUTOTEC",
            "firstname": "AUTOTEK",
            "surname": "AUTOTEK"
          },
          {
            "id": 1705,
            "companyname": "NATIONAL WINDSCREENS CHESTERFIELD",
            "firstname": "NATIONAL WINDSCREENS CHESTERFIELD",
            "surname": "NATIONAL WINDCREENS CHESTERFIELD"
          },
          {
            "id": 1710,
            "companyname": "BRISTOL STREET MOTORS CHESTERFIELD",
            "firstname": "BRISTOL STREET MOTORS CHESTERFIELD",
            "surname": "BRISTOL STREET MOTORS CHESTERFIELD"
          },
          {
            "id": 1713,
            "companyname": "PERRYS MANSFIELD",
            "firstname": "PERRYS MANSFIELD",
            "surname": "PERRYS MANSFIELD"
          },
          {
            "id": 1745,
            "companyname": "Kia Chesterfield",
            "firstname": "Kia Chesterfield",
            "surname": "Kia Chesterfield"
          },
          {
            "id": 1780,
            "companyname": "Nuffield Accident Repair",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1663,
            "companyname": "MJS Services",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1664,
            "companyname": "Peterborough Tyre & Battery Ltd",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1665,
            "companyname": "Car & Commercial Garage Ltd",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1666,
            "companyname": "Tears of Sutton Bridge",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1667,
            "companyname": "B&T Motors limited ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1668,
            "companyname": "Accident Repair Specialist",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1774,
            "companyname": "Newmarket Motor Company",
            "firstname": "Rob",
            "surname": ""
          },
          {
            "id": 417,
            "companyname": "Duckend",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 418,
            "companyname": "Felsted",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 419,
            "companyname": "The Manor",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 420,
            "companyname": "Owen (practical parking)",
            "firstname": "Owen",
            "surname": ""
          },
          {
            "id": 429,
            "companyname": "Runaround Vehicle",
            "firstname": "Runaround",
            "surname": "Vehicle"
          },
          {
            "id": 434,
            "companyname": "PR Motors",
            "firstname": "Philip",
            "surname": "White"
          },
          {
            "id": 438,
            "companyname": "Rowland Ridgwells ltd",
            "firstname": "Sally / Ben",
            "surname": ""
          },
          {
            "id": 439,
            "companyname": "SR Motors Works",
            "firstname": "Jodie / Scott",
            "surname": ""
          },
          {
            "id": 440,
            "companyname": "Smarts",
            "firstname": "Jamie / Rob",
            "surname": ""
          },
          {
            "id": 441,
            "companyname": "Airport Garage Services",
            "firstname": "Bruce",
            "surname": ""
          },
          {
            "id": 442,
            "companyname": "Oakdene Autos",
            "firstname": "Reece / Tracy",
            "surname": ""
          },
          {
            "id": 444,
            "companyname": "Toomey Renault ",
            "firstname": "Charlie",
            "surname": ""
          },
          {
            "id": 445,
            "companyname": "",
            "firstname": "Quest Motor Group",
            "surname": ""
          },
          {
            "id": 446,
            "companyname": "Quest Vauxhall",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 450,
            "companyname": "Ash Mahoney",
            "firstname": "Ashley ",
            "surname": "Mahoney"
          },
          {
            "id": 451,
            "companyname": "Specialist Vehicle solutions",
            "firstname": "steve",
            "surname": "Manning"
          },
          {
            "id": 452,
            "companyname": "Algarve",
            "firstname": "Tom",
            "surname": ""
          },
          {
            "id": 453,
            "companyname": "Barnston travel",
            "firstname": "Richard",
            "surname": "Barnston Travel"
          },
          {
            "id": 454,
            "companyname": "Andy Mahoney",
            "firstname": "Andy",
            "surname": "Mahoney"
          },
          {
            "id": 455,
            "companyname": "Awaiting Delivery",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 456,
            "companyname": "T AND S VEHICLE REPAIRS NORFOLK",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 458,
            "companyname": "Arrived @N/W",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 461,
            "companyname": "Mag airport",
            "firstname": "Mag airport",
            "surname": ""
          },
          {
            "id": 465,
            "companyname": "COMPLETE TAIL LIFT SOLUTIONS",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 467,
            "companyname": "",
            "firstname": "SPEEDY SCREENS YARD",
            "surname": ""
          },
          {
            "id": 468,
            "companyname": "",
            "firstname": "SPEEDY SCREENS",
            "surname": ""
          },
          {
            "id": 469,
            "companyname": "SPEEDY SCREENS",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 470,
            "companyname": "KIA WESTDRIVE BRAINTREE",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 480,
            "companyname": "ROBINS AND DAY",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 481,
            "companyname": "Motts Hall",
            "firstname": "Motts Hall",
            "surname": ""
          },
          {
            "id": 485,
            "companyname": "Peugeot Main Dealer",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 492,
            "companyname": "compound",
            "firstname": "compound",
            "surname": ""
          },
          {
            "id": 503,
            "companyname": "Long Stay Q",
            "firstname": "Long Stay Q",
            "surname": ""
          },
          {
            "id": 513,
            "companyname": "WR MOTORS",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 516,
            "companyname": "TRANSCITY",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 519,
            "companyname": "Gates",
            "firstname": "Ford Gates",
            "surname": ""
          },
          {
            "id": 520,
            "companyname": "Delivered",
            "firstname": "Delivered",
            "surname": ""
          },
          {
            "id": 525,
            "companyname": "Boyers Garage",
            "firstname": "Boyers Garage",
            "surname": ""
          },
          {
            "id": 582,
            "companyname": "Quest Citroen SOR",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 585,
            "companyname": "Mid Stay car park A",
            "firstname": "Mid stay car park A",
            "surname": ""
          },
          {
            "id": 586,
            "companyname": "Adam Motor garage ltd",
            "firstname": "Adams Motor",
            "surname": ""
          },
          {
            "id": 589,
            "companyname": "Bristol Street Harlow",
            "firstname": "bristol street Harlow",
            "surname": ""
          },
          {
            "id": 590,
            "companyname": "Essex Autos repair",
            "firstname": "Essex Autos ",
            "surname": ""
          },
          {
            "id": 591,
            "companyname": "WestdrIve SOR",
            "firstname": "Westdrive SOR",
            "surname": ""
          },
          {
            "id": 592,
            "companyname": "",
            "firstname": "Chaple hill Garage ",
            "surname": ""
          },
          {
            "id": 593,
            "companyname": "Station Coachworks",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 595,
            "companyname": "Pickrell Ltd",
            "firstname": "Chris",
            "surname": ""
          },
          {
            "id": 598,
            "companyname": "Marshalls Oxford",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 599,
            "companyname": "DM Keith Leeds",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 600,
            "companyname": "DM Keith Leeds",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 602,
            "companyname": "STN - Awaiting Garage",
            "firstname": "Awaiting Garage",
            "surname": ""
          },
          {
            "id": 618,
            "companyname": "",
            "firstname": "Midstay A",
            "surname": ""
          },
          {
            "id": 619,
            "companyname": "",
            "firstname": "Midstay B",
            "surname": ""
          },
          {
            "id": 620,
            "companyname": "",
            "firstname": "Midstay B",
            "surname": ""
          },
          {
            "id": 621,
            "companyname": "Midstay B",
            "firstname": "Midstay  B",
            "surname": ""
          },
          {
            "id": 622,
            "companyname": "Midstay C",
            "firstname": "Midstay C",
            "surname": ""
          },
          {
            "id": 623,
            "companyname": "Midstay D",
            "firstname": "Midstay D",
            "surname": ""
          },
          {
            "id": 624,
            "companyname": "Midstay E",
            "firstname": "Midstay E",
            "surname": ""
          },
          {
            "id": 625,
            "companyname": "Midstay F",
            "firstname": "MIdstay F",
            "surname": ""
          },
          {
            "id": 627,
            "companyname": "Midstay G",
            "firstname": "Midstay G",
            "surname": ""
          },
          {
            "id": 628,
            "companyname": "Midstay H",
            "firstname": "Midstay H",
            "surname": ""
          },
          {
            "id": 636,
            "companyname": "Smart repair centre",
            "firstname": "Smart repair centre",
            "surname": ""
          },
          {
            "id": 637,
            "companyname": "kia",
            "firstname": "Kia",
            "surname": ""
          },
          {
            "id": 638,
            "companyname": "Bodyworx ltd",
            "firstname": "Bodyworx ltd",
            "surname": ""
          },
          {
            "id": 650,
            "companyname": "Aske Stables North Storage",
            "firstname": "Aske Stables north storage",
            "surname": ""
          },
          {
            "id": 651,
            "companyname": "Ian Norfolk",
            "firstname": "Ian Norfolk",
            "surname": "Ian Batley"
          },
          {
            "id": 652,
            "companyname": "Hardground",
            "firstname": "hardground ",
            "surname": ""
          },
          {
            "id": 653,
            "companyname": "Marshs Farm Dunmow",
            "firstname": "Marshs Farm Dunmow",
            "surname": ""
          },
          {
            "id": 656,
            "companyname": "HAARLEM STORAGE DERBYSHIRE",
            "firstname": "HAARLEM STORAGE DERBYSHIRE",
            "surname": "HAARLEM STORAGE DERBYSHIRE",
            "lat":53.070278,
            "lon":-1.578056
          },
          {
            "id": 658,
            "companyname": "Norfolk Office",
            "firstname": "Norfolk Office",
            "surname": "Ian Batley"
          },
          {
            "id": 970,
            "companyname": "Muirs Vehicle Services",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 977,
            "companyname": "Chaple hill Garage ",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 988,
            "companyname": "Underwoods Vauxhall",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1567,
            "companyname": "The workshop  bodyshop",
            "firstname": "dave",
            "surname": "Thompson"
          },
          {
            "id": 1630,
            "companyname": "Glyn Hopkins Chelmsford",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1631,
            "companyname": "Glyn Hopkins Chelmsford",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1726,
            "companyname": "Steven Eagell Toyota",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1776,
            "companyname": "Leicester Storage ",
            "firstname": "Leicesters storage ",
            "surname": ""
          },
          {
            "id": 1788,
            "companyname": "The Old Vicarage Restaurant",
            "firstname": "Neil ",
            "surname": "Manning "
          },
          {
            "id": 932,
            "companyname": "24X7 ECL",
            "firstname": "24x7 ECL",
            "surname": "",
            "lat":51.866944,
            "lon":0.504167
          },
          {
            "id": 1641,
            "companyname": "Approved Autos",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1682,
            "companyname": "Colour Motion",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1648,
            "companyname": "West Yorkshire Office",
            "firstname": "",
            "surname": ""
          },
          {
            "id": 1649,
            "companyname": "South Yorkshire Office",
            "firstname": "",
            "surname": ""
          }
        ]
      };
    },
    mounted() {
      const thiz = this;
      fetch(this.$host+'/searchinspection', {
        method:'POST',
        mode: "cors",
        cache: 'no-cache',
        headers: {
          'Content-type':'application/json'
        },
        credentials:'include',
        body:JSON.stringify({reg:this.$route.params.reg, mylast:false})
      }).then(res=>res.json()).then(res=>{
        if (res.error){
          console.log('application error #940', res);
  //        errorBox('Application error #940', res.error);
        }
        else {
  //        renderInspections(res);
          thiz.inspections = res.inspections;
          for (var i=0;i<res.inspections.length; i++) {
            res.inspections[i].inspectionSummary = getInspectionSummary(res.inspections[i], thiz);
            
          }
        }
      }).catch(err=>{
        console.log('system error #947', err);[0], null
;  //      errorBox('System error #947', err.message);
      });
      setTimeout(()=>{
        const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
        e.onfinish = ()=>{
          document.querySelector('#purpleheader').style.height = "130px";
        };
      },0);
    },
  }
</script>
